/// <amd-module name="ServiceHooks/Web/Admin/RestClient/ServiceHooks" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   servicehooks\web\extensions\vss-servicehooks-web\vss-servicehooks-admin\clientgeneratorconfigs\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Notifications from "ServiceHooks/Web/Admin/Contracts/Notifications";
import * as ServiceHooks from "ServiceHooks/Web/Admin/Contracts/ServiceHooks";

export interface IServiceHooksRestClient extends IVssRestClient {
    /**
     * Get a list of available service hook consumer services. Optionally filter by consumers that support at least one event type from the specific publisher.
     * 
     * @param publisherId - 
     */
    listConsumers(publisherId?: string): Promise<ServiceHooks.Consumer[]>;
    /**
     * @param subscriptionId - 
     */
    getSubscriptionDiagnostics(subscriptionId: string): Promise<Notifications.SubscriptionDiagnostics>;
    /**
     * @param updateParameters - 
     * @param subscriptionId - 
     */
    updateSubscriptionDiagnostics(updateParameters: Notifications.UpdateSubscripitonDiagnosticsParameters, subscriptionId: string): Promise<Notifications.SubscriptionDiagnostics>;
    /**
     * @param inputValuesQuery - 
     */
    postInputValuesQuery(inputValuesQuery: ServiceHooks.SubscriptionInputValuesQuery): Promise<ServiceHooks.SubscriptionInputValuesQuery>;
    /**
     * Get a specific notification for a subscription.
     * 
     * @param subscriptionId - ID for a subscription.
     * @param notificationId - 
     */
    getNotification(subscriptionId: string, notificationId: number): Promise<ServiceHooks.Notification>;
    /**
     * Query for notifications. A notification includes details about the event, the request to and the response from the consumer service.
     * 
     * @param query - 
     */
    queryNotifications(query: ServiceHooks.NotificationsQuery): Promise<ServiceHooks.NotificationsQuery>;
    /**
     * Query for service hook publishers.
     * 
     * @param query - 
     */
    queryPublishers(query: ServiceHooks.PublishersQuery): Promise<ServiceHooks.PublishersQuery>;
    /**
     * Create a subscription.
     * 
     * @param subscription - Subscription to be created.
     */
    createSubscription(subscription: ServiceHooks.Subscription): Promise<ServiceHooks.Subscription>;
    /**
     * Delete a specific service hooks subscription.
     * 
     * @param subscriptionId - ID for a subscription.
     */
    deleteSubscription(subscriptionId: string): Promise<void>;
    /**
     * Update a subscription. \<param name="subscriptionId"\>ID for a subscription that you wish to update.\</param\>
     * 
     * @param subscription - 
     * @param subscriptionId - 
     */
    replaceSubscription(subscription: ServiceHooks.Subscription, subscriptionId?: string): Promise<ServiceHooks.Subscription>;
    /**
     * Query for service hook subscriptions.
     * 
     * @param query - 
     */
    createSubscriptionsQuery(query: ServiceHooks.SubscriptionsQuery): Promise<ServiceHooks.SubscriptionsQuery>;
    /**
     * Sends a test notification. This is useful for verifying the configuration of an updated or new service hooks subscription.
     * 
     * @param testNotification - 
     * @param useRealData - Only allow testing with real data in existing subscriptions.
     */
    createTestNotification(testNotification: ServiceHooks.Notification, useRealData?: boolean): Promise<ServiceHooks.Notification>;
}

class ServiceHooksRestClient extends RestClientBase implements IServiceHooksRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Get a list of available service hook consumer services. Optionally filter by consumers that support at least one event type from the specific publisher.
     * 
     * @param publisherId - 
     */
    public async listConsumers(
        publisherId?: string
        ): Promise<ServiceHooks.Consumer[]> {

        const queryValues: any = {
            publisherId: publisherId
        };

        return this.beginRequest<ServiceHooks.Consumer[]>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/hooks/Consumers/{consumerId}",
            queryParams: queryValues
        });
    }

    /**
     * @param subscriptionId - 
     */
    public async getSubscriptionDiagnostics(
        subscriptionId: string
        ): Promise<Notifications.SubscriptionDiagnostics> {

        return this.beginRequest<Notifications.SubscriptionDiagnostics>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/hooks/subscriptions/{subscriptionId}/diagnostics",
            routeValues: {
                subscriptionId: subscriptionId
            }
        });
    }

    /**
     * @param updateParameters - 
     * @param subscriptionId - 
     */
    public async updateSubscriptionDiagnostics(
        updateParameters: Notifications.UpdateSubscripitonDiagnosticsParameters,
        subscriptionId: string
        ): Promise<Notifications.SubscriptionDiagnostics> {

        return this.beginRequest<Notifications.SubscriptionDiagnostics>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "_apis/hooks/subscriptions/{subscriptionId}/diagnostics",
            routeValues: {
                subscriptionId: subscriptionId
            },
            body: updateParameters
        });
    }

    /**
     * @param inputValuesQuery - 
     */
    public async postInputValuesQuery(
        inputValuesQuery: ServiceHooks.SubscriptionInputValuesQuery
        ): Promise<ServiceHooks.SubscriptionInputValuesQuery> {

        return this.beginRequest<ServiceHooks.SubscriptionInputValuesQuery>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/hooks/InputValuesQuery",
            body: inputValuesQuery
        });
    }

    /**
     * Get a specific notification for a subscription.
     * 
     * @param subscriptionId - ID for a subscription.
     * @param notificationId - 
     */
    public async getNotification(
        subscriptionId: string,
        notificationId: number
        ): Promise<ServiceHooks.Notification> {

        return this.beginRequest<ServiceHooks.Notification>({
            apiVersion: "5.0-preview.1",
            routeTemplate: "_apis/hooks/subscriptions/{subscriptionId}/Notifications/{notificationId}",
            routeValues: {
                subscriptionId: subscriptionId,
                notificationId: notificationId
            }
        });
    }

    /**
     * Query for notifications. A notification includes details about the event, the request to and the response from the consumer service.
     * 
     * @param query - 
     */
    public async queryNotifications(
        query: ServiceHooks.NotificationsQuery
        ): Promise<ServiceHooks.NotificationsQuery> {

        return this.beginRequest<ServiceHooks.NotificationsQuery>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/hooks/NotificationsQuery",
            body: query
        });
    }

    /**
     * Query for service hook publishers.
     * 
     * @param query - 
     */
    public async queryPublishers(
        query: ServiceHooks.PublishersQuery
        ): Promise<ServiceHooks.PublishersQuery> {

        return this.beginRequest<ServiceHooks.PublishersQuery>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/hooks/PublishersQuery",
            body: query
        });
    }

    /**
     * Create a subscription.
     * 
     * @param subscription - Subscription to be created.
     */
    public async createSubscription(
        subscription: ServiceHooks.Subscription
        ): Promise<ServiceHooks.Subscription> {

        return this.beginRequest<ServiceHooks.Subscription>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/hooks/Subscriptions/{subscriptionId}",
            body: subscription
        });
    }

    /**
     * Delete a specific service hooks subscription.
     * 
     * @param subscriptionId - ID for a subscription.
     */
    public async deleteSubscription(
        subscriptionId: string
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "5.0-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/hooks/Subscriptions/{subscriptionId}",
            routeValues: {
                subscriptionId: subscriptionId
            }
        });
    }

    /**
     * Update a subscription. \<param name="subscriptionId"\>ID for a subscription that you wish to update.\</param\>
     * 
     * @param subscription - 
     * @param subscriptionId - 
     */
    public async replaceSubscription(
        subscription: ServiceHooks.Subscription,
        subscriptionId?: string
        ): Promise<ServiceHooks.Subscription> {

        return this.beginRequest<ServiceHooks.Subscription>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "_apis/hooks/Subscriptions/{subscriptionId}",
            routeValues: {
                subscriptionId: subscriptionId
            },
            body: subscription
        });
    }

    /**
     * Query for service hook subscriptions.
     * 
     * @param query - 
     */
    public async createSubscriptionsQuery(
        query: ServiceHooks.SubscriptionsQuery
        ): Promise<ServiceHooks.SubscriptionsQuery> {

        return this.beginRequest<ServiceHooks.SubscriptionsQuery>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/hooks/SubscriptionsQuery",
            body: query
        });
    }

    /**
     * Sends a test notification. This is useful for verifying the configuration of an updated or new service hooks subscription.
     * 
     * @param testNotification - 
     * @param useRealData - Only allow testing with real data in existing subscriptions.
     */
    public async createTestNotification(
        testNotification: ServiceHooks.Notification,
        useRealData?: boolean
        ): Promise<ServiceHooks.Notification> {

        const queryValues: any = {
            useRealData: useRealData
        };

        return this.beginRequest<ServiceHooks.Notification>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "_apis/hooks/TestNotifications/{notificationId}",
            queryParams: queryValues,
            body: testNotification
        });
    }

}

export const ServiceHooksClientName = "ServiceHooks-Admin.IServiceHooksRestClient";

export function getServiceHooksClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IServiceHooksRestClient {
    return pageContext.getRestClient<IServiceHooksRestClient>(ServiceHooksClientName, options);
}

RestClients.add(ServiceHooksClientName, { 
    factory: ServiceHooksRestClient
});
